<template>
  <v-layout>
    <modal-new-order ref="newOrder"></modal-new-order>
    <modal-new-valuation ref="newValuation"></modal-new-valuation>
    <modal-order-sms ref="sendSms"></modal-order-sms>
    <modal-order-email ref="sendEmail"></modal-order-email>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <ServicesFilters></ServicesFilters>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Usługi
          </v-card-title>
          <v-card-text>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
            >
              <template v-slot:item.name="{ item }">
                <span v-if="item.carRental">
                  {{ item.name }}
                </span>
                <span v-else>
                  {{ item.type.name }}
                </span>
              </template>
              <template v-slot:item.category="{ item }">
                {{ item.type.category }}
              </template>
              <template v-slot:item.partner="{ item }">
                {{ item.company.name }} - {{ item.branch.name }}
              </template>
              <template v-slot:item.price="{ item }">
                <span v-if="item.carRental">
                  Ceny w zależności od długości wynajmu
                </span>
                <span v-else-if="item.availableWithTransport">
                  <span v-if="item.priceWithTransport === null">
                    Wycena
                  </span>
                  <span v-else>
                    {{ 'Z transportem: ' + item.priceWithTransport + 'zł/' + item.unit }}
                  </span>
                </span>
                <span v-else-if="item.availableWithoutTransport">
                  <span v-if="item.priceWithoutTransport === null">
                    Wycena
                  </span>
                  <span v-else>
                    {{ 'Bez transportu: ' + item.priceWithoutTransport + 'zł/' + item.unit }}
                  </span>
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn @click="sendSms(item)" class="mb-2 mr-2">Wyślij SMS</v-btn>
                <v-btn @click="sendEmail(item)" class="mb-2 mr-2">Wyślij E-mail</v-btn>
                <v-btn @click="copyList(item)" class="mb-2 mr-2">Kopiuj link</v-btn>
                <v-btn @click="order(item)" class="mb-2">{{isValuation(item) ? 'Złóż zapytanie' : 'Złóż zamówienie' }}</v-btn>
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '../services/api';
import formatters from '@/mixins/formatters';
import DataTable from '@/components/data-table/DataTable';
import filters from '@/mixins/filters';
import {getDatatableParams, setDatatableFilters, setDatatableOptions} from '@/utils/helpers';
import ServicesFilters from "@/components/ServicesFilters";
import ModalNewOrder from "@/components/ModalNewOrder";
import ModalNewValuation from "@/components/ModalNewValuation";
import ModalOrderSms from "@/components/ModalOrderSms";
import ModalOrderEmail from "@/components/ModalOrderEmail.vue";

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    ModalNewValuation,
    ModalNewOrder,
    ModalOrderSms,
    ModalOrderEmail,
    ServicesFilters,
    DataTable,
  },
  data() {
    return {
      landingBaseUrl: process.env.VUE_APP_LANDING_URL,
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Nazwa', value: 'name', sortable: false},
        {text: 'Kategoria', value: 'category', sortable: false},
        {text: 'Partner', value: 'partner', sortable: false},
        {text: 'Cena', value: 'price', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      editedIndex: -1,
      editedText: '',
      editedEvent: null,
    }
  },
  mounted() {
    const self = this;

    this.$root.$on('loadServices', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler () {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
    filters: {
      handler() {
        setDatatableFilters.call(this);
        this.load();
      },
      deep: true
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'category', filters.category);
      this.appendStringFilterIfNonEmpty(params, 'partner', filters.partner);
      this.appendStringFilterIfNonEmpty(params, 'city', filters.city ? (filters.city.charAt(0).toUpperCase() + filters.city.slice(1)) : null);
    },
    isValuation(service) {
      return (service.availableWithTransport && service.priceWithTransport === null) || (service.availableWithoutTransport && service.priceWithoutTransport === null);
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;

      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/service', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy usług.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    order(service) {
      this.isValuation(service) ? this.$refs.newValuation.open(service) : this.$refs.newOrder.open(service);
    },
    sendSms(service) {
      this.$refs.sendSms.open(service);
    },
    sendEmail(service) {
      this.$refs.sendEmail.open(service);
    },
    copyList(service) {
      const link = this.landingBaseUrl + '/?order=' + service.id + '&withTransport=' + (service.availableWithTransport ? 'true' : 'false') + '&s=' + localStorage.getItem('code');
      navigator.clipboard.writeText(link);

      this.$root.$emit('notifySuccess', {
        html: `Link został skopiowany do schowka`,
      });
    }
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/components/VSlideGroup/_variables.scss';

// $slide-group-prev-basis: 10px;
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>